// DS: IL9.3
import React from 'react';

export const LeaveGroup: React.FC = () => {
  return (
    <svg width="88" height="88" xmlns="http://www.w3.org/2000/svg">
      <image
        href="https://st.deviantart.net/eclipse/global/images/leave-group.png?1"
        width="100%"
        height="100%"
      />
    </svg>
  );
};
LeaveGroup.displayName = 'LeaveGroup';
